import createClient from 'openapi-fetch';

import { config } from '@/config/config';
import type { paths } from '@/types/apiSchema';

import { authMiddleware } from './middlewares/authMiddleware';
import { errorMiddleware } from './middlewares/errorMiddleware';

export const fetchClient = createClient<paths>({
  baseUrl: config.app.apiBaseUrl,
  credentials: 'include',
});

fetchClient.use(errorMiddleware);
fetchClient.use(authMiddleware);
